import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { NewContainerProps } from "../../../interfaces/containers";
import New from "../../../pages/Sell/New";
import { 
    getModels, 
    cleanGetModels, 
    getVersions, 
    cleanGetVersions, 
    setNewVariant,
    setRemoveVariant,
    postDatasheetFile,
    clearPostDatasheetFile,
    deleteDatasheetFile,
    clearDeleteDatasheetFile,
    updateVariants,
    postPublicationNew,
    cleanPostPublicationNew
} from "../../../actions/salePost";
import { setColor as setColorReducer } from "../../../actions/colors";

function mapStateToProps(state: NewContainerProps) {
    return{
        user: state.auth.user,
        brand: state.salePost.new.brand,
        variants: state.salePost.new.variants,
        models: state.salePost.models,
        versionsData: state.salePost.versions,
        versionsFetching: state.salePost.fetchingVersions,
        datasheet: state.salePost.new.datasheet,
        colors: state.colors.colors,
        fetchingPostPublication: state.salePost.new.fetchingPostPublication
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        setNewVariant,
        setRemoveVariant,
        getModels, 
        cleanGetModels, 
        getVersions, 
        cleanGetVersions,
        postDatasheetFile,
        clearPostDatasheetFile,
        deleteDatasheetFile,
        clearDeleteDatasheetFile,
        setColorReducer,
        updateVariants,
        postPublicationNew,
        cleanPostPublicationNew
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(New);